import { useEffect, useRef } from 'react';

// Custom event for requesting the order-summary modal to open. Lets deep step
// components (e.g. cash-or-finance) open the root-owned OrderSummary modal
// without prop-drilling its state through the funnel.
const OPEN_ORDER_SUMMARY_EVENT = 'purchase-ui:open-order-summary';

/**
 * Dispatches a custom event requesting the order-summary modal to open.
 */
export const triggerOpenOrderSummary = () => {
  window.dispatchEvent(new CustomEvent(OPEN_ORDER_SUMMARY_EVENT));
};

/**
 * Hook that listens for the open-order-summary event and runs the callback.
 * Mounted by the root, which owns the OrderSummary modal state.
 */
export const useOpenOrderSummary = (onOpen: () => void) => {
  const onOpenRef = useRef(onOpen);

  useEffect(() => {
    onOpenRef.current = onOpen;
  }, [onOpen]);

  useEffect(() => {
    const listener = () => {
      onOpenRef.current();
    };
    window.addEventListener(OPEN_ORDER_SUMMARY_EVENT, listener);
    return () => {
      window.removeEventListener(OPEN_ORDER_SUMMARY_EVENT, listener);
    };
  }, []);
};
